import { useQuery } from '@tanstack/react-query';

import { canUseOrdersRecognitionWithAi } from '@entities/order-recognition/globals';
import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';

export const useGetOrdersRecognitionList = () =>
    useQuery({
        ...ordersRecognitionApi.getOrdersRecognitionListQueryOptions(),
        enabled: canUseOrdersRecognitionWithAi,
    });
